import React, { useState } from "react";
import { useMediaQuery } from "react-responsive";
import IconButton from "@mui/material/IconButton";
import DeleteIcon from "@mui/icons-material/Delete";
import Navbar from "../layout/nav/navbar/Navbar";
import Navmenu from "../layout/nav/navmenu/Navmenu";
import Sidebar from "../layout/sidebar/Sidebar";
import Footer from "../layout/Footer/Footer";
import "./Cart.css";
import { Link } from "react-router-dom";
import LockIcon from "@mui/icons-material/Lock";

function Cart() {
  const isMobile = useMediaQuery({ query: "(max-width: 500px)" });

  // Get cart items from localStorage
  const [cartItems, setCartItems] = useState(
    JSON.parse(localStorage.getItem("incart")) || []
  );

  // Calculate the total price
  const totalPrice = cartItems.reduce(
    (acc, item) => acc + item.ProductPrice * item.quantity,
    0
  );

  // Handle quantity change
  const handleQuantityChange = (itemId, newQty) => {
    const updatedCartItems = cartItems.map((item) => {
      if (item.id === itemId) {
        return { ...item, quantity: Math.max(newQty, 1) }; // Minimum quantity is 1
      }
      return item;
    });
    setCartItems(updatedCartItems);
    localStorage.setItem("incart", JSON.stringify(updatedCartItems)); // Update localStorage
  };

  // Handle delete item
  const handleDelete = (itemId) => {
    const updatedCartItems = cartItems.filter((item) => item.id !== itemId);
    setCartItems(updatedCartItems); // Update state
    localStorage.setItem("incart", JSON.stringify(updatedCartItems)); // Update localStorage
  };

  return (
    <>
      <Navbar />
      {isMobile ? <Sidebar /> : <Navmenu />}
      <div className="cart-container">
        <h1>Your Cart</h1>
        {cartItems.length === 0 ? (
          <p>Your cart is empty.</p>
        ) : (
          <div className="cart-content">
            <div className="cart-items">
              {cartItems.map((item) => (
                <div className="cart-item" key={item.id}>
                  <Link
                    to={`/product/${item.ProductName}`}
                    className="product-link"
                  >
                    <img
                      src={item.ProductImgs.high[0]} // Display the first high-quality image
                      alt={item.ProductName}
                      className="cart-item-image"
                    />
                  </Link>
                  <div >
                  <p className="cart-item-price"> ₹{item.ProductPrice.toFixed(2)}</p>
                    <p className="cart-item-name">{item.ProductName}</p>
                    
                    <div className="quantity-selector">
                      <button
                        onClick={() =>
                          handleQuantityChange(item.id, item.quantity - 1)
                        }
                        className="quantity-button"
                      >
                        -
                      </button>
                      <input
                        type="text"
                        value={item.quantity}
                        readOnly
                        className="quantity-input"
                      />
                      <button
                        onClick={() =>
                          handleQuantityChange(item.id, item.quantity + 1)
                        }
                        className="quantity-button"
                      >
                        +
                      </button>
                    </div>
                    <p>Made with {item.Purity}  {item.MetalType}</p>
                    {/* Size Selector */}
                    <div className="size-selector">
                      <label htmlFor="size">Size:</label>
                      <select id="size" name="size">
                        <option value={item.size}>{item.size}</option>
                        <option value="2.2">2.2</option>
                        <option value="2.4">2.4</option>
                        <option value="2.6">2.6</option>
                        <option value="2.8">2.8</option>
                        <option value="2.10">2.10</option>
                        <option value="2.12">2.12</option>
                      </select>
                    </div>
                    <div className="btns">
                      <button className="wishlist-button">
                        Move to Wishlist
                      </button>
                      <IconButton
                        aria-label="delete"
                        onClick={() => handleDelete(item.id)}
                      >
                        <DeleteIcon
                          fontSize="large"
                          style={{ color: "var(--firstbackground)" }}
                        />
                      </IconButton>
                    </div>
                  </div>
                </div>
              ))}
            </div>

            {/* Order Summary */}
            <div className="order-summary">
              <h2>Order Summary</h2>
              <div className="summary-item">
                <p>Item total:</p>
                <p>₹{totalPrice.toFixed(2)}</p>
              </div>
              <div className="summary-item">
                <p>Subscription savings (15% off):</p>
                <p>₹{(totalPrice * 0.15).toFixed(2)}</p>
              </div>
              <div className="summary-item">
                <p>Shipping:</p>
                <p>Free</p>
              </div>
              <div className="summary-item total">
                <h3>Order Total:</h3>
                <h3>₹{(totalPrice - totalPrice * 0.15).toFixed(2)}</h3>
              </div>
              <Link to="/checkout" className="checkout-link">
                <button className="checkout-button">
                  <LockIcon
                    className="checkout-icon"
                    sx={{ color: "white", fontSize: "1.5rem" }}
                  />
                  <span className="checkout-text">CHECKOUT SECURELY</span>
                </button>
              </Link>
            </div>
          </div>
        )}
      </div>
      <Footer />
    </>
  );
}

export default Cart;
